
import Vue from "vue";
import Component from "vue-class-component";
import { isLightColor, randomPalette } from "@/lib/singularity/brand/colors/palettes";
import { NamedColorPalette } from "@/types/singularity/brand";
import { Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { singularityStore } from "@/store/store";

@Component({
  components: {
    Icon
  }
})
export default class BrandPaletteGenerator extends Vue {
  isOverlayOpen = false;

  @Prop()
  palette!: NamedColorPalette;

  @Prop({ default: false })
  neutral!: boolean;

  @Prop()
  index?: number;

  openEditColorPanel() {
    if (!this.palette || this.palette.locked) return;
    singularityStore.setSingularityLeftPanel("brand_edit_color");
    singularityStore.setCurrentPalette({
      palette: this.palette,
      index: this.index ?? null
    });
  }

  get textStyle() {
    if (!this.palette) return {};
    return {
      color: isLightColor(this.palette.base.value?.toString())
        ? this.palette.scale[900].value?.toString()
        : this.palette.scale[100].value?.toString()
    };
  }

  get primaryTagStyle() {
    if (!this.palette) return {};
    return {
      backgroundColor: isLightColor(this.palette.base.value?.toString())
        ? this.palette.scale[600].value?.toString()
        : this.palette.scale[600].value?.toString(),
      color: isLightColor(this.palette.base.value?.toString())
        ? this.palette.scale[900].value?.toString()
        : this.palette.scale[100].value?.toString()
    };
  }

  updatePalette(palette: NamedColorPalette) {
    this.$emit("update", {
      ...palette,
      primary: this.palette.primary,
      locked: this.palette.locked
    });
  }

  removePalette() {
    this.$emit("remove");
  }

  lockPalette() {
    this.$emit("update", {
      ...this.palette,
      locked: !this.palette.locked
    });
  }

  shufflePalette() {
    const newPalette = randomPalette(
      this.palette.primary,
      this.index ? this.index + 1 : 1
    );
    this.updatePalette(newPalette);
  }

  get isLightColor() {
    if (!this.palette?.base) return false;
    return isLightColor(this.palette.base.value?.toString());
  }
}
